import { get, post, put, destroy } from '@/api/request';

function fetchTimeLogs(params) {
  return get('/time_logs', params);
}

function fetchRunningTimeLog(params = {}) {
  return get('/time_logs/running', params);
}

function fetchAllRunningTimeLog(params = {}) {
  return get('/time_logs/allrunning', params);
}

function createTimeLog(data) {
  return post('/time_logs', data);
}

function updateTimeLog({ id, data }) {
  return put(`/time_logs/${id}`, data);
}

function startTimer(data) {
  return post('/time_logs/start', data);
}

function stopTimer(data) {
  return put('/time_logs/stop', data);
}

function deleteTimeLog(id) {
  return destroy(`/time_logs/${id}`);
}

export default {
  fetchTimeLogs,
  fetchRunningTimeLog,
  fetchAllRunningTimeLog,
  createTimeLog,
  updateTimeLog,
  startTimer,
  stopTimer,
  deleteTimeLog,
};



// WEBPACK FOOTER //
// ./src/store/modules/timeLog/api.js